'use client'

import { ClientLabel } from 'labels/client'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { useProductCardStock } from 'product-card/hooks/useProductCardStock'
import type { ProductColor } from 'product/types'

interface SizesAmountLabelProps {
	productColors: ProductColor[]
}

export const SizesAmountLabel = ({ productColors }: SizesAmountLabelProps) => {
	const { t } = useLabels()
	const { totalProductSizes } = useProductCardStock({ productColors })

	const placeholderSizesValue = totalProductSizes
		? { 1: totalProductSizes.toString() }
		: undefined

	return (
		placeholderSizesValue && (
			<ClientLabel placeholderValues={placeholderSizesValue}>
				{t('plp.home.sizes.text.withVariable')}
			</ClientLabel>
		)
	)
}
